module.exports = function() {
  return new Worker(__webpack_public_path__ + "010602c8d3e394477abf.worker.js");
};